import { createClient } from 'payload-rest-client';
import { Config } from '@/types';

type Locale = 'en';

// Temel parametre tipleri
interface BaseParams {
  locale?: Locale;
  draft?: boolean;
  depth?: number;
  fallbackLocale?: Locale;
}

// Find işlemi için parametreler
interface FindParams extends BaseParams {
  where?: Record<string, any>;
  sort?: string;
  limit?: number;
  page?: number;
  skip?: number;
}

// FindByID işlemi için parametreler
interface FindByIdParams extends BaseParams {
  id: string | number;
}

// Create işlemi için parametreler
interface CreateParams extends BaseParams {
  data: Record<string, any>;
}

// Update işlemi için parametreler
interface UpdateParams extends CreateParams {
  where?: Record<string, any>;
}

// UpdateByID işlemi için parametreler
interface UpdateByIdParams extends BaseParams {
  id: string | number;
  data: Record<string, any>;
}

// Delete işlemi için parametreler
interface DeleteParams extends BaseParams {
  where?: Record<string, any>;
}

// DeleteByID işlemi için parametreler
interface DeleteByIdParams extends BaseParams {
  id: string | number;
}

// Auth işlemleri için parametreler
interface LoginParams extends BaseParams {
  data: {
    email: string;
    password: string;
  };
}

interface ForgotPasswordParams extends BaseParams {
  data: {
    email: string;
  };
}

interface ResetPasswordParams extends BaseParams {
  token: string;
  data: {
    password: string;
  };
}

// Global işlemleri için parametreler
interface GetGlobalParams extends BaseParams {}

interface UpdateGlobalParams extends BaseParams {
  data: Record<string, any>;
}

// Koleksiyon tiplerine erişim için yardımcı tip
export type CollectionType<T extends keyof Config['collections']> = Config['collections'][T];

// API istemcisini oluşturan factory fonksiyon
export function createApiClient(apiUrl: string, options: { debug?: boolean } = {}, headers?: Record<string, string>) {
  return createClient<Config, Locale>({
    apiUrl,
    debug: options.debug,
    headers,
  });
}

// Singleton API istemcisi
let apiClient: ReturnType<typeof createClient<Config, Locale>> | null = null;

// API istemcisini döndüren fonksiyon
export function getApiClient() {
  if (!apiClient) {
    // API URL'sini oluştur
    let apiUrl = 'http://localhost:3030/api';

    if (typeof window !== 'undefined') {
      // Client-side'da next.js proxy'sini kullanın
      apiUrl = '/api/proxy';
    } else if (process.env.NEXT_PUBLIC_PAYLOAD_API_URL) {
      // Server-side'da doğrudan PayloadCMS'ye bağlanın
      apiUrl = `${process.env.NEXT_PUBLIC_PAYLOAD_API_URL}/api`;
    }
    // if (process.env.NEXT_PUBLIC_PAYLOAD_API_URL) {
    //   apiUrl = `${process.env.NEXT_PUBLIC_PAYLOAD_API_URL}/api`;
    // } else if (typeof window !== 'undefined') {
    //   apiUrl = `https://cave.orkhan.art/api`;
    // }

    apiClient = createApiClient(
      apiUrl,
      { debug: false },
      {
        Authorization: `users API-Key ${process.env.NEXT_PUBLIC_PAYLOAD_API_KEY}`,
      },
    );
  }
  return apiClient;
}
